import {EntityKey} from '../entity/entity';

export class SabrPurchaseOrder {
  purchaseOrderNumber!: string;
  customerName!: string;
  currentEncompassOrder: EntityKey = new EntityKey();
  project!: string;
  salesRepName!: string;
  quantity!: number;
  amount!: number;
  salesChannelCode!: string;
}
